import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  path,
  mergeDeepLeft,
  clone,
} from 'ramda';
import Input from '../../common/Input';
import Select from '../../common/Select';
import CheckBox from '../../common/CheckBox';
import TextArea from '../../common/TextArea';
import MultiSelect from '../../common/MultiSelect';
import fields from './fields';
import Breadcrumbs from '../../common/Breadcrumbs';
import { processFields } from '../../utils/prePost';
import { validateFields } from '../../utils/validate';
import '../../css/forms/default-forms.css';
import { createStage } from '../../api/boardStage';
import { fetchAllEmailTemplates } from '../../api/emailTemplate';

export class AddStage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submit: false,
      errors: [],
      fields: fields,
      fieldsSync: false
    };
    this.submit = this.submit.bind(this);
    this.changeFormValue = this.changeFormValue.bind(this);
    this.getEmailTemplateList = this.getEmailTemplateList.bind(this);
    this.cancel = this.cancel.bind(this);
    this.convertEmailTemplateList = this.convertEmailTemplateList.bind(this);    
  }

  componentWillMount() {
    this.props.emailTemplateList();
  }

  componentDidMount(){
    let arrSendTo = this.getSendToList();
    let stateClone = clone(this.state);
    stateClone.fields['email_template'].value = arrSendTo.slice();
    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  cancel() {
    this.props.goToBoardEditor();
  }

  getEmailTemplateList() {
    const emailTemplateSource = path(['emailTemplate', 'list'], this.props) || [];
    const emailTemplateList = [{
      value: 0,
      text: 'None'
    }];

    for (let i = 0; i < emailTemplateSource.length; i++) {
      emailTemplateList.push({
        value: emailTemplateSource[i].id,
        text: emailTemplateSource[i].name,
      })
    }
    return emailTemplateList;
  }

  getSendToList() {
    const sendToList = [
      {
        value: 'send_to_bp',
        checked: false,
        label: 'Business Person'
      },
      {
        value: 'send_to_sp',
        checked: false,
        label: 'Sales Person'
      },
      {
        value: 'send_to_c',
        checked: false,
        label: 'Client'
      },
      {
        value: 'send_to_w',
        checked: false,
        label: 'Worker'
      },
    ]
    return sendToList;
  }

  submit(e) {
    e.preventDefault();
    let result = validateFields(this.state.fields);
    if (result.check === false) {
      this.setState({
        fields: result.fields,
      });
    } else {
      let data = processFields(this.state.fields);
      this.props.saveForm(this.convertEmailTemplateList(data));
    }
    return false;
  }

  convertEmailTemplateList(data) {    
    data.email_template = data.email_template.map(function(item) {
      let obj = {};
      obj.name = item.value;
      obj.value = item.checked;
      return obj;
    });
    return data;
  }

  changeFormValue(field, newObject) {
    let stateClone = clone(this.state);
    stateClone.fields[field] = newObject;
    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  render() {
    let multiSelect = null;
    if (this.state.fields['email_template_id'].value !== "0" ) {
      multiSelect =  (
        <MultiSelect
          options={this.state.fields['email_template'].value ? this.state.fields['email_template'].value : this.getSendToList()}
          field={this.state.fields['email_template']}
          onChange={this.changeFormValue}
        />
      )
    }
    return (
      <div className="row">
        <div className="col">
          <Breadcrumbs list={[
           { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
           { url: '/pages/boardsettings', icon: 'settings', name: 'Board Settings' },
           { icon: 'add_box', name: 'Add Stage' },
           ]} />
          <div className="card rounded">
            <div className="card-header rounded-top">
              Add Stage
            </div>
            <div className="card-block">
              <div className="col-12" style={{ paddingBottom: '40px' }}>
                <button
                  className={'btn btn-danger btn-outline float-right'}
                  style={{ marginLeft: '10px' }}
                  onClick={this.cancel}
                >
                  <i className="fa fa-remove"></i>
                  <span style={{ paddingLeft: '3px' }}>Cancel</span>
                </button>
                <button className={'btn btn-success btn-outline float-right'} onClick={this.submit}>
                  <i className="fa fa-check"></i>
                  <span style={{ paddingLeft: '3px' }}>Save & Continue</span>
                </button>
              </div>
              <form onSubmit={this.submit}>
                <div className="col-12">
                  <Input
                    field={this.state.fields['label']}
                    onChange={this.changeFormValue}
                  />
                  <TextArea
                    field={this.state.fields['description']}
                    onChange={this.changeFormValue}
                  />
                  <CheckBox
                    field={this.state.fields['start_clock']}
                    onChange={this.changeFormValue}
                  />
                  <Select
                    options={this.getEmailTemplateList()}
                    field={this.state.fields['email_template_id']}
                    onChange={this.changeFormValue}
                  />
                  {multiSelect}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    goToBoardEditor: () => {
      dispatch(push('/pages/boardsettings'));
    },
    saveForm: (data) => {
      createStage(data)(dispatch);
    },
    emailTemplateList: () => {
      fetchAllEmailTemplates()(dispatch);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddStage);



// WEBPACK FOOTER //
// ./src/containers/AddStage/index.js